import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { PatientsComponent } from './patients/patients.component';
import { AppointmentsGeneralComponent } from './appointments-general/appointments-general.component';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { NavComponent } from './nav/nav.component';
import { BillingComponent } from './billing/billing.component';
import { PatdetailsComponent } from './patdetails/patdetails.component';
import { PrintAppointmentsComponent } from './print-appointments/print-appointments.component';
import { BillingReportsComponent } from './billing-reports/billing-reports.component';
import { PrintBillingReportComponent } from './print-billing-report/print-billing-report.component';
import { PrintQuestionnaireComponent } from './print-questionnaire/print-questionnaire.component';
import { AuthGuard } from './auth.guard';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TrainingHubComponent } from './training-hub/training-hub.component';
import { AttendanceTrackerComponent } from './attendance-tracker/attendance-tracker.component';
import { AttendanceReportComponent } from './attendance-report/attendance-report.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';





const routes: Routes = [
 // Currently AuthGuard is in use only In routes which codeLogin is involved
  {path: 'appointments', component: AppointmentsGeneralComponent, canActivate: [AuthGuard]},
  {path: 'appointments/:code', component: AppointmentsGeneralComponent, canActivate: [AuthGuard]},
  {path: 'appointments/:code/:pid', component: AppointmentsGeneralComponent, canActivate: [AuthGuard]},
  {path: 'appointments/patient/:pid', component: AppointmentsGeneralComponent, canActivate: [AuthGuard]},
  {path: 'billing', component: BillingComponent, canActivate: [AuthGuard]},
  {path: 'billing/:code', component: BillingComponent, canActivate: [AuthGuard]},
  {path: 'billing/:code/:pid', component: BillingComponent, canActivate: [AuthGuard]},
  {path: 'billing-reports', component: BillingReportsComponent},
  {path: 'patient', component: PatdetailsComponent},
  {path: 'settings', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'questionnaires', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'questionnaires/:code', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'questionnaires/:code/:pid', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'financial', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'financial/:code', component: UserSettingsComponent, canActivate: [AuthGuard]},
  {path: 'attendance', component: AttendanceTrackerComponent, canActivate: [AuthGuard]},
  {path: 'attendance-report', component: AttendanceReportComponent, canActivate: [AuthGuard]},
  {path: 'main/:code', component: NavComponent, canActivate: [AuthGuard] },
  {path: 'main', component: NavComponent },
  {path: 'print/:type/:startDate/:docUID', component: PrintAppointmentsComponent},
  {path: 'print/:type/:startDate/:docUID/:code', component: PrintAppointmentsComponent},
  {path: 'print/report/:docType/:fromDate/:toDate/:docUID', component: PrintBillingReportComponent},
  {path: 'print/report/:docType/:fromDate/:toDate/:docUID/:code', component: PrintBillingReportComponent},
  {path: 'print/questionnaire/:code', component: PrintQuestionnaireComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'training-hub', component: TrainingHubComponent},
  {path: 'no-access', component: AccessDeniedComponent},
  {path: '', component: LoginComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
